import React from 'react';
import { useIntl } from 'react-intl';
import RequestStepInfoContent from '@/requests/components/RequestStepInfoContent';
import Selectors from '../hooks/selectors';
import Fetch from '../hooks/fetch';

const WorkspaceRequestInfo = ({ code, hideSteps }) => {
  const intl = useIntl();
  const {
    fields, readErrors, readStatus, saveErrors, saveStatus, workspace,
  } = Selectors.useWorkspaceRequestInfo({ code });
  Fetch.useFetchFormForWorkspaceRequest({ code, intl }, readStatus);

  return (
    <RequestStepInfoContent
      category="workspaces"
      code={code}
      fields={fields}
      hideSteps={hideSteps}
      readErrors={readErrors}
      readStatus={readStatus}
      request={workspace}
      section="workspace"
      saveErrors={saveErrors}
      saveStatus={saveStatus}
    />
  );
};

export default WorkspaceRequestInfo;
